<template>
  <div class="dropdown user-dropdown">
    <a class="d-none main d-lg-flex nav-link px-0 py-3 mx-2 align-items-center fw-sbold" href="#" id="navbarScrollingDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
      <div class="text mx-2">{{ $store.state.member.user_name || "Member" }}</div>
      <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.3837 1.20492L6 4.95273L9.6163 1.20492C9.94427 0.865026 10.4768 0.865026 10.8047 1.20492C11.1318 1.54381 11.1318 2.09255 10.8047 2.43144L6.59422 6.79508C6.59421 6.79509 6.5942 6.7951 6.59419 6.79511C6.26622 7.13497 5.73373 7.13496 5.40578 6.79508L1.19525 2.43144C0.86825 2.09255 0.86825 1.54381 1.19525 1.20492C1.52322 0.865026 2.05573 0.865026 2.3837 1.20492Z" fill="#6B7280" stroke="#6B7280" stroke-width="0.1" stroke-linecap="round" stroke-linejoin="round"/></svg>
    </a>
    <div class="user-dropdown-menu mx-2 mx-lg-0 dropdown-menu dropdown-menu-end p-lg-2" aria-labelledby="navbarScrollingDropdown">
      <div class="card p-lg-3 border-0">
        <div class="d-flex flex-column align-items-center gap-1">
          <div>
            <div class="thumb me-2">
              {{ $store.state.member.initials || "AI" }}
            </div>
          </div>
          <div class="d-flex flex-column align-items-center justify-content-between w-100">
            <div>
              <div class="text-center fw-bold">{{ $store.state.member.user_name || "Member" }}</div>
              <div v-if="$store.state.member.email" class="smaller text-x-muted text-center">{{ $store.state.member.email }}</div>
            </div>
          </div>
          <div class="mt-2 fw-bold small">
            {{ tokensUsed }} / {{ totalTokensPlan }} Tokens
          </div>
        </div>
      </div>
      <div class="mx-n2 mt-2 user-options-section">
        <router-link to="/whitelabel" class="nav-link d-flex align-items-center text small text-nowrap py-2 px-3" v-if="$store.state.showWhiteLabel">
          <!-- <div class="card" :style="{ width: '18rem', color:'white', fontWeight: 900, backgroundRepeat: 'round', backgroundImage: 'url(' + banner + ')' }">
            <div class="card-body">
              <h5 class="card-title">EZAI.io</h5>
              <p class="card-text text-wrap">Want Your Own AI Platform to Resell? Contact Us</p>
            </div>
          </div> -->
          <img :src="banner" >
        </router-link>
        <router-link v-if="!$store.state.member.isSubAccount" to="/pricing" class="nav-link d-flex align-items-center text small text-nowrap py-2 px-3">
          <svg class="me-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1847_24715)"><path d="M2.5 6.66675C2.5 6.00371 2.76339 5.36782 3.23223 4.89898C3.70107 4.43014 4.33696 4.16675 5 4.16675H15C15.663 4.16675 16.2989 4.43014 16.7678 4.89898C17.2366 5.36782 17.5 6.00371 17.5 6.66675V13.3334C17.5 13.9965 17.2366 14.6323 16.7678 15.1012C16.2989 15.57 15.663 15.8334 15 15.8334H5C4.33696 15.8334 3.70107 15.57 3.23223 15.1012C2.76339 14.6323 2.5 13.9965 2.5 13.3334V6.66675Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M2.5 8.33325H17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5.83325 12.5H5.84159" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9.16675 12.5H10.8334" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_1847_24715"><rect width="20" height="20" fill="white"/></clipPath></defs></svg>
          Pricing
        </router-link>
        <a href="#" @click.prevent="$root.$children[0].$refs.preferencesModal.show()" class="nav-link d-flex align-items-center text small text-nowrap py-2 px-3">
          <svg class="me-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1847_24728)"><path d="M10 4.99992C10 5.44195 10.1756 5.86587 10.4882 6.17843C10.8007 6.49099 11.2246 6.66659 11.6667 6.66659C12.1087 6.66659 12.5326 6.49099 12.8452 6.17843C13.1577 5.86587 13.3333 5.44195 13.3333 4.99992C13.3333 4.55789 13.1577 4.13397 12.8452 3.82141C12.5326 3.50885 12.1087 3.33325 11.6667 3.33325C11.2246 3.33325 10.8007 3.50885 10.4882 3.82141C10.1756 4.13397 10 4.55789 10 4.99992Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.33325 5H9.99992" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.3333 5H16.6666" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M5 9.99992C5 10.4419 5.17559 10.8659 5.48816 11.1784C5.80072 11.491 6.22464 11.6666 6.66667 11.6666C7.10869 11.6666 7.53262 11.491 7.84518 11.1784C8.15774 10.8659 8.33333 10.4419 8.33333 9.99992C8.33333 9.55789 8.15774 9.13397 7.84518 8.82141C7.53262 8.50885 7.10869 8.33325 6.66667 8.33325C6.22464 8.33325 5.80072 8.50885 5.48816 8.82141C5.17559 9.13397 5 9.55789 5 9.99992Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.33325 10H4.99992" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.33325 10H16.6666" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M12.5 14.9999C12.5 15.4419 12.6756 15.8659 12.9882 16.1784C13.3007 16.491 13.7246 16.6666 14.1667 16.6666C14.6087 16.6666 15.0326 16.491 15.3452 16.1784C15.6577 15.8659 15.8333 15.4419 15.8333 14.9999C15.8333 14.5579 15.6577 14.134 15.3452 13.8214C15.0326 13.5088 14.6087 13.3333 14.1667 13.3333C13.7246 13.3333 13.3007 13.5088 12.9882 13.8214C12.6756 14.134 12.5 14.5579 12.5 14.9999Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M3.33325 15H12.4999" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15.8333 15H16.6666" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_1847_24728"><rect width="20" height="20" fill="white"/></clipPath></defs></svg>
          Preferences
        </a>
        <router-link to="/user/settings/account" class="nav-link d-flex align-items-center text small text-nowrap py-2 px-3">
          <svg width="20" class="me-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 011.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 01-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 01-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.107-1.204l-.527-.738a1.125 1.125 0 01.12-1.45l.773-.773a1.125 1.125 0 011.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894z" /><path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
          Settings
        </router-link>
        <a href="#" class="nav-link d-flex align-items-center justify-content-between text small text-nowrap py-2 px-3 dropdown">
          <div class="d-flex align-items-center">
            <svg class="me-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M14 10C14 12.2091 12.2091 14 10 14V6C12.2091 6 14 7.79086 14 10Z" fill="currentColor"/></svg>
            Theme
          </div>
          <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L1 9" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <div class="submenu">
            <div class="card py-2 me-4">
              <a href="#" @click.prevent="selectTheme('theme-white')" class="nav-link d-flex align-items-center justify-content-between text small text-nowrap px-3 py-2">
                Light
                <svg v-if="theme == 'theme-white'" width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 3.66667L3.66667 6.33333L9 1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </a>
              <a href="#" @click.prevent="selectTheme('theme-black')" class="nav-link d-flex align-items-center justify-content-between text small text-nowrap px-3 py-2">
                Dark
                <svg v-if="theme == 'theme-black'" width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 3.66667L3.66667 6.33333L9 1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </a>
              <a href="#" @click.prevent="() => {}" class="nav-link d-flex align-items-center justify-content-between text small text-nowrap px-3 py-2">
                System Theme
                <div class="badge text-uppercase bg-secondary px-1 fw-bold ms-2" style="font-size: 9px;">
                  Soon
                </div>
                <svg v-if="theme == 'theme-system'" width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 3.66667L3.66667 6.33333L9 1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </a>
            </div>
          </div>
        </a>
        <router-link to="/wizard" class="nav-link d-flex align-items-center text small text-nowrap py-2 px-3">
          <svg class="me-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.91675 4.58333L4.16675 5.83333L6.25008 3.75M2.91675 9.58333L4.16675 10.8333L6.25008 8.75M2.91675 14.5833L4.16675 15.8333L6.25008 13.75M9.16675 5H16.6667M9.16675 10H16.6667M9.16675 15H16.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          Set-up Wizard
        </router-link>
        <a href="#" @click="logout" class="nav-link d-flex align-items-center text small text-nowrap py-2 px-3">
          <svg class="me-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1847_24741)"><path d="M11.6667 6.66659V4.99992C11.6667 4.55789 11.4911 4.13397 11.1785 3.82141C10.866 3.50885 10.442 3.33325 10 3.33325H4.16667C3.72464 3.33325 3.30072 3.50885 2.98816 3.82141C2.67559 4.13397 2.5 4.55789 2.5 4.99992V14.9999C2.5 15.4419 2.67559 15.8659 2.98816 16.1784C3.30072 16.491 3.72464 16.6666 4.16667 16.6666H10C10.442 16.6666 10.866 16.491 11.1785 16.1784C11.4911 15.8659 11.6667 15.4419 11.6667 14.9999V13.3333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.5 10H17.5L15 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M15 12.5L17.5 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_1847_24741"><rect width="20" height="20" fill="white"/></clipPath></defs></svg>
          Log Out
        </a>
      </div>
      <div v-if="currentPlan == 'premium'" class="mx-n2 mt-2 user-options-section">
        <div class="d-flex align-items-center justify-content-between text small text-nowrap px-3">
          <div class="d-flex align-items-center">
            <svg data-v-5fa8991e="" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path data-v-5fa8991e="" d="M15.9815 16.7247C15.2828 15.7996 14.3788 15.0493 13.3407 14.5331C12.3026 14.0168 11.1589 13.7487 9.99953 13.7497C8.84017 13.7487 7.69641 14.0168 6.65834 14.5331C5.62028 15.0493 4.71627 15.7996 4.01753 16.7247M15.9815 16.7247C17.345 15.5119 18.3066 13.9133 18.7407 12.1408C19.1748 10.3683 19.0598 8.50579 18.411 6.80018C17.7622 5.09457 16.6103 3.62648 15.1079 2.5906C13.6056 1.55472 11.8239 1 9.99903 1C8.17419 1 6.39246 1.55472 4.89013 2.5906C3.3878 3.62648 2.23585 5.09457 1.58706 6.80018C0.938265 8.50579 0.823276 10.3683 1.25734 12.1408C1.69141 13.9133 2.65403 15.5119 4.01753 16.7247M15.9815 16.7247C14.3355 18.1929 12.2052 19.0028 9.99953 18.9997C7.79355 19.0031 5.66376 18.1931 4.01753 16.7247M12.9995 7.74971C12.9995 8.54535 12.6835 9.30842 12.1208 9.87103C11.5582 10.4336 10.7952 10.7497 9.99953 10.7497C9.20388 10.7497 8.44081 10.4336 7.8782 9.87103C7.3156 9.30842 6.99953 8.54535 6.99953 7.74971C6.99953 6.95406 7.3156 6.19099 7.8782 5.62838C8.44081 5.06578 9.20388 4.74971 9.99953 4.74971C10.7952 4.74971 11.5582 5.06578 12.1208 5.62838C12.6835 6.19099 12.9995 6.95406 12.9995 7.74971Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            &nbsp; Sub Accounts
          </div>
          <a hreff="#" @click="openSubAccountModal()" class="nav-link d-flex align-items-center text small text-nowrap py-2 px-3 add-subaccount-btn">
            <svg class="me-2" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.75 9C0.75 10.0834 0.963392 11.1562 1.37799 12.1571C1.7926 13.1581 2.40029 14.0675 3.16637 14.8336C3.93245 15.5997 4.84193 16.2074 5.84286 16.622C6.8438 17.0366 7.91659 17.25 9 17.25C10.0834 17.25 11.1562 17.0366 12.1571 16.622C13.1581 16.2074 14.0675 15.5997 14.8336 14.8336C15.5997 14.0675 16.2074 13.1581 16.622 12.1571C17.0366 11.1562 17.25 10.0834 17.25 9C17.25 7.91659 17.0366 6.8438 16.622 5.84286C16.2074 4.84193 15.5997 3.93245 14.8336 3.16637C14.0675 2.40029 13.1581 1.7926 12.1571 1.37799C11.1562 0.963393 10.0834 0.75 9 0.75C7.91659 0.75 6.8438 0.963393 5.84286 1.37799C4.84193 1.7926 3.93245 2.40029 3.16637 3.16637C2.40029 3.93245 1.7926 4.84193 1.37799 5.84286C0.963392 6.8438 0.75 7.91659 0.75 9Z" fill="#DC2631"/><path d="M5 9H13" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M9 5V13" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </a>
        </div>
        <div style="max-height: 150px; overflow-y: scroll;">
          <div v-for="subAccount in subAccounts" :key="subAccount.id" @click.stop class="d-flex align-items-center text small text-nowrap py-2 px-3 justify-content-between sub-account-item">
            <div class="d-flex align-items-center">
              <div class="thumb me-2">
                  {{ getInitials(subAccount.name) }}
              </div>
              {{subAccount.name}}
            </div>
            <div class="sub-account-btns">
              <a @click.stop.prevent="openSubAccountModal('update', subAccount)" href="#" class="text" data-bs-toggle="tooltip" title="Edit">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.33325 16.6663H6.66659L15.4166 7.91627C15.8586 7.47424 16.1069 6.87472 16.1069 6.2496C16.1069 5.62448 15.8586 5.02496 15.4166 4.58293C14.9746 4.14091 14.375 3.89258 13.7499 3.89258C13.1248 3.89258 12.5253 4.14091 12.0833 4.58293L3.33325 13.3329V16.6663Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.25 5.41699L14.5833 8.75033" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </a>
              <a @click.prevent="archivesubAccount(subAccount.id)" href="#" class="text" data-bs-toggle="tooltip" title="Archive">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.8333 6.66634C16.2754 6.66634 16.6993 6.49075 17.0118 6.17819C17.3244 5.86563 17.5 5.4417 17.5 4.99967C17.5 4.55765 17.3244 4.13372 17.0118 3.82116C16.6993 3.5086 16.2754 3.33301 15.8333 3.33301H4.16667C3.72464 3.33301 3.30072 3.5086 2.98816 3.82116C2.67559 4.13372 2.5 4.55765 2.5 4.99967C2.5 5.4417 2.67559 5.86563 2.98816 6.17819C3.30072 6.49075 3.72464 6.66634 4.16667 6.66634M15.8333 6.66634H4.16667M15.8333 6.66634V14.9997C15.8333 15.4417 15.6577 15.8656 15.3452 16.1782C15.0326 16.4907 14.6087 16.6663 14.1667 16.6663H5.83333C5.39131 16.6663 4.96738 16.4907 4.65482 16.1782C4.34226 15.8656 4.16667 15.4417 4.16667 14.9997V6.66634M8.33333 9.99967H11.6667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddSubAccountModal @onAdd="addOrUpdateSubAccount" ref="addSubAccountModal" />
  </div>
</template>

<script>
  import config from '@/api-services/_config';
  import AuthService from '@/api-services/auth.service';
  import subaccountService from '@/api-services/subaccount.service';
  import AddSubAccountModal from '@/modals/add-sub-account-modal.vue';

  export default {
    name: 'UserOptions',
    components: { AddSubAccountModal },
    data() {
      return {
        theme: localStorage.getItem('theme'),
        subAccounts:[],
        currentPlan: ''
      }
    },
    mounted() {
      this.getCurrentPlan();
    },
    computed: {
      tokensUsed() {
        return this.$store.state.tokensUsed;
      },
      totalTokensPlan(){
        switch (this.$store.state.currentPlan) {
          case 'free':
            return 90000;
          case 'starter':
            return 180000;
          case 'premium':
            return 465000;
          case 'enterprise':
            return '-';
          default: return '';
        }
      },
      banner() {
        return require('@/assets/images/banner-background.svg');
      }
    },
    methods: {
      async getCurrentPlan() {
        await this.$store.dispatch('getCurrentPlan');
        this.currentPlan = this.$store.state.currentPlan;
        if(this.currentPlan == 'premium') {
          this.fetchSubAccounts();
        }
      },
      selectTheme(theme) {
        this.theme = theme;
        this.$root.$children[0].selectTheme(theme);
      },
      async logout() {
        let res = await AuthService.logout();
        if(res.success) {
          document.cookie = "ezai_auth_session_cookie=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          window.location = config.urlAuth;
        }
      },
      async openSubAccountModal(action = 'create', subAccount = {}) {
        this.$refs.addSubAccountModal.show(action, subAccount);
      },
      addOrUpdateSubAccount(subAccount) {
        subaccountService.create(subAccount).then(res => {
          if(!res.success) {
            this.$toast(res.error, 'error');
            return;
          }

         this.$toast(res.message,'success');
          this.fetchSubAccounts();

        }).catch(err => {
          this.$toast(err.message, 'error');
        });
      },
      fetchSubAccounts() {
        subaccountService.fetch().then(res => {
          if(res.success) {
            this.subAccounts = res.subAccounts
          }
        }).catch(err => {
          this.$toast(err.message, 'error');
        });
      },
      getInitials(name) {
          if (!name || typeof name !== 'string') {
              return 'AI';
          }

          const words = name.trim().split(/\s+/);
          if (words.length === 1) {
              return words[0].substring(0, 2).toUpperCase();
          } else {
              return (words[0][0] + words[1][0]).toUpperCase();
          }
      },
      archivesubAccount(id) {
        this.$swal({
          title: 'Are you sure?',
          text: 'Are you sure, you want to delete this sub account?',
          icon: 'warning',
          showCancelButton: true
          }).then(async res => {
            if(res.isConfirmed) {
              subaccountService.delete({id}).then(res => {
                if(res.success) {
                  this.$toast(res.message,'success');
                  this.fetchSubAccounts();
                }
              }).catch(err => {
                this.$toast(err.message, 'error');
              });
            }
          })
      }
    }
  }
</script>

<style scoped lang="scss">
  .user-dropdown {
    .avatar {
      width: 28px;
      height: 28px;
      border-radius: 28px;
      object-fit: cover;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .user-dropdown-menu {
    > .card {
      min-width: 236px;
    }
    .dropdown {
      .submenu {
        position: absolute;
        display: none;
        transform: translateX(-100%);
        top: 0;
      }
      &:hover {
        .submenu {
          display: block !important;
        }
      }
    }
    .thumb {
      width: 32px;
      height: 32px;
      font-size: 12px;
      font-weight: 600;
      background: #FBE6C9;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 32px;
    }
    @media (max-width: 991px) {
      display: block !important;
      background: none !important;
      box-shadow: none !important;
      .card {
        box-shadow: none !important;
      }
    }
  }
  .nav-link {
    &.main {
      height: 60px;
      &:hover {
        background: inherit !important;
      }
    }
  }

  .user-options-section{
    border-bottom: solid 1px #E5E7EB;
  }

  .add-subaccount-btn:hover{
    background: #F7F8FA;
    cursor: pointer;
  }
  .sub-account-item .sub-account-btns{
    visibility: hidden;
  }
  .sub-account-item:hover .sub-account-btns {
    visibility: visible;
  }
  .sub-account-item:hover{
    background: #F7F8FA;
    cursor: pointer;
  }
</style>
